/*
 * File: /src/store/modules/lostReasons.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import LostReasonService from 'src/services/lostReasonService';
import LostReasonDetailService from 'src/services/lostReasonDetailService.js';

const state = {
  lostReasons: undefined,
  lostReasonDetails: undefined,
};

const getters = {
  getLostReasons: state => {
    return state.lostReasons;
  },
  getLostReasonDetails: state => lostReasonId => state.lostReasonDetails ? state.lostReasonDetails.filter(lrd => lrd.lost_reason_id == lostReasonId) : []
};
const actions = {
  async fetchLostReasons({ commit, state, rootGetters }) {
    if (state.lostReasons == undefined) {
      const res = await LostReasonService.fetchAll();
      commit('setLostReasons', res.data);
    }
  },
  async fetchLostReasonDetails({ commit, state, rootGetters }) {
    if (state.lostReasonDetails == undefined) {
      const deets = await LostReasonDetailService.fetchAll();
      commit('setLostReasonDetails', deets.data);
    }
  },
  unloadLostReasons({ commit }) {
    commit('setLostReasons', undefined);
  },
  unloadLostReasonDetails({ commit }) {
    commit('setLostReasonDetails', undefined);
  },
};
const mutations = {
  setLostReasons(state, lostReasons) {
    state.lostReasons = lostReasons;
  },
  setLostReasonDetails(state, lostReasonDetails) {
    state.lostReasonDetails = lostReasonDetails;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
